import type { IBattleConfig } from '@typings/battle/monster.interface';

const DEFAULT_CRITICAL_STAT_CAP = 300;
const DEFAULT_MAX_CRITICAL_CHANCE = 99;

function toFiniteNumber(value: unknown, fallback: number): number {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
}

export function resolveCriticalChanceByStat(
  criticalStat: number,
  config?: Pick<IBattleConfig, 'criticalStatCap' | 'maxCriticalChance'>,
): number {
  const stat = Math.max(0, toFiniteNumber(criticalStat, 0));
  const statCap = Math.max(
    1,
    toFiniteNumber(config?.criticalStatCap, DEFAULT_CRITICAL_STAT_CAP),
  );
  const maxChance = Math.min(
    99,
    Math.max(
      0,
      toFiniteNumber(config?.maxCriticalChance, DEFAULT_MAX_CRITICAL_CHANCE),
    ),
  );

  return Math.min(maxChance, (stat / statCap) * maxChance);
}

export function rollCriticalByStat(
  criticalStat: number,
  config?: Pick<IBattleConfig, 'criticalStatCap' | 'maxCriticalChance'>,
): boolean {
  return Math.random() * 100 < resolveCriticalChanceByStat(criticalStat, config);
}
